import {FocusableEvent, HorizontalList} from 'focus-manager/web';
import * as React from 'react';

import IRail from '../Interfaces/IRail';
import IRailState from '../Interfaces/IRailState';
import createNextRailState from '../Util/createNextRailState';

import Tile from './Tile';

class Rail extends React.Component<IRail, IRailState> {
    private trackElement: HTMLDivElement | null = null;

    constructor(props: IRail) {
        super(props);

        this.handleResize = this.handleResize.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.manipulateReceivedFocus = this.manipulateReceivedFocus.bind(this);
        this.setTrackElementReference = this.setTrackElementReference.bind(this);

        this.state = createNextRailState({
            tileCount: this.props.tiles.length,
        });
    }

    public proxySetState(nextState: Partial<IRailState>): void {
        this.setState(createNextRailState(this.state, nextState));
    }

    public componentDidMount(): void {
        this.updateDimensions();

        window.addEventListener('resize', this.handleResize);
    }

    public componentWillUnmount(): void {
        window.removeEventListener('resize', this.handleResize);
    }

    public render(): React.ReactNode {
        const railClassName = [
            'rail',
            this.state.isAtLeftEdge && 'rail--at-left-edge',
            this.state.isAtRightEdge && 'rail--at-right-edge',
        ]
            .filter(Boolean)
            .join(' ');

        return (
            <HorizontalList
                className={railClassName}
                onFocus={this.handleFocusChange}
                actions={{
                    focus: this.manipulateReceivedFocus,
                }}
            >
                <h2 className="rail__heading">{this.props.title}</h2>
                <div className="rail__track" ref={this.setTrackElementReference} style={this.getRailTrackStyle()}>
                    {this.props.tiles.map(tile => (
                        <Tile {...tile} key={tile.id} />
                    ))}
                </div>
            </HorizontalList>
        );
    }

    private setTrackElementReference(trackElement: HTMLDivElement): void {
        this.trackElement = trackElement;
    }

    private updateDimensions(): void {
        const trackPadding = parseInt(window.getComputedStyle(this.trackElement!).paddingLeft!);

        const tileWidths = Array.from(this.trackElement!.children).map(tileElement => {
            const tileElementStyles = window.getComputedStyle(tileElement);

            return parseInt(tileElementStyles.width!) + parseInt(tileElementStyles.marginRight!);
        });

        this.proxySetState({
            tileWidths,
            trackPadding,
            viewportWidth: window.innerWidth,
        });
    }

    private getRailTrackStyle(): React.CSSProperties {
        return {
            transform: `translateX(${this.state.trackX}px)`,
        };
    }

    private handleResize(): void {
        this.updateDimensions();
    }

    private handleFocusChange(e: FocusableEvent): void {
        const nextNode = e.target;

        this.proxySetState({
            index: nextNode.index,
        });
    }

    private manipulateReceivedFocus(): number[] {
        return [this.state.index];
    }
}

export default Rail;
